import { useQuery } from "@apollo/client";
import { GET_CONTRACT_DETAIL } from "graphql/contract/query";
import { useParams } from "react-router-dom";

const useDetail = () => {
  const { id } = useParams();

  const { data, loading, refetch } = useQuery(GET_CONTRACT_DETAIL, {
    variables: { id },
    fetchPolicy: "cache-and-network",
  });

  const contractDetail = data?.contractQuery?.getByID || {};

  return {
    contractDetail,
    loading,
    refetch,
  };
};

export default useDetail;
